@if (config$ | async; as setting) {
  <div class="config-panel">
    <h2 class="headline mb-4">
      <mat-icon class="mr-3" svgIcon="mat:settings"></mat-icon>
      <span>Configuration</span>
    </h2>
    <div class="section">
      <h5 class="subheading">THEME BASE</h5>
      <div
        (click)="isDark ? disableDarkMode() : enableDarkMode()"
        *ngrxLet="isDark$; let isDark"
        class="rounded-full mt-2 flex items-center cursor-pointer relative bg-contrast-black text-contrast-white select-none"
        matRipple
      >
        <div class="m-2 h-6 w-6 rounded-full">
          @if (isDark) {
            <mat-icon svgIcon="mat:check"></mat-icon>
          }
          @if (!isDark) {
            <mat-icon svgIcon="mat:close"></mat-icon>
          }
        </div>
        <p class="ml-1 font-medium text-sm">DARK MODE</p>
      </div>
    </div>
    <div class="section">
      <h5 class="subheading">THEME COLORS</h5>
      @for (color of colorVariables | keyvalue; track color) {
        <div
          (click)="selectColor(color.value)"
          [class.selected]="isSelectedColor(color.value)"
          [style.backgroundColor]="color.value.light"
          [style.color]="color.value.default"
          class="ratenow-color-picker rounded-full mt-2 flex items-center cursor-pointer relative"
          matRipple
        >
          <div [style.backgroundColor]="color.value.default" class="m-2 h-6 w-6 rounded-full">
            @if (isSelectedColor(color.value)) {
              <mat-icon svgIcon="mat:check"></mat-icon>
            }
          </div>
          <p class="ml-1 font-medium text-sm">{{ color.key | uppercase }}</p>
        </div>
      }
    </div>
    <!-- <div class="section">
    <h5 class="subheading">PRE-BUILT STYLES</h5>
    <div
      *ngFor="let config of configs; let first = first"
      [class.mt-6]="!first"
      class="rounded"
      >
      <div
        class="layout-image rounded overflow-hidden relative hover:bg-hover shadow-md"
        >
        <img [src]="config.imgSrc" class="w-full block" />
        <div
          class="layout-image-overlay flex items-center justify-center gap-1"
          >
          <button
            (click)="setConfig(config.id, ColorSchemeName.light)"
            class="bg-contrast-white text-contrast-black flex-none !min-w-0"
            matButton="filled"
            type="button"
            >
            LIGHT
          </button>
          <button
            (click)="setConfig(config.id, ColorSchemeName.default)"
            color="primary"
            class="flex-none !min-w-0"
            matButton="filled"
            type="button"
            >
            DEFAULT
          </button>
          <button
            (click)="setConfig(config.id, ColorSchemeName.dark)"
            class="bg-contrast-black text-contrast-white flex-none !min-w-0"
            matButton="filled"
            type="button"
            >
            DARK
          </button>
        </div>
      </div>
      <div class="text-center body-2 mt-2">{{ config.name }}</div>
    </div>
  </div> -->
  </div>
}
